import * as React from "react";
import { cn } from "@/lib/utils";

export type StatusTone = "alert" | "warning" | "success" | "neutral" | "accent";

// Backgrounds are mixed onto the card colour, not see-through, so a tinted row (hover, selected)
// can't pull the text below 4.5:1
const TONES: Record<StatusTone, string> = {
  alert:   "bg-[color-mix(in_srgb,hsl(var(--destructive))_10%,hsl(var(--card)))] text-destructive",
  warning: "bg-highlight text-highlight-foreground",
  success: "bg-[color-mix(in_srgb,hsl(var(--success))_10%,hsl(var(--card)))] text-success",
  neutral: "bg-muted text-muted-foreground",
  accent:  "bg-[color-mix(in_srgb,hsl(var(--primary))_10%,hsl(var(--card)))] text-primary",
};

/** Small status label — the only five tones the redesign uses. */
export function StatusChip({ tone, children, className }: { tone: StatusTone; children: React.ReactNode; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-2xs font-semibold whitespace-nowrap", TONES[tone], className)}>
      {children}
    </span>
  );
}
